// extracted by mini-css-extract-plugin
module.exports = {"button":"teamsButton-module--button--3irvN","inactive":"teamsButton-module--inactive--dmI9J"};